<template>
  <div>
    <slot :seckillInfo="seckillInfo" />
  </div>
</template>

<script>
  import Vue from 'vue'
  import { getSeckillInfo } from '@/utils'

  export default Vue.extend({
    props: {
      // 场次数据
      data: {
        type: Object,
        required: true,
      },
      // 是否禁用
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      seckillInfo: {},
    }),

    watch: {
      data: {
        immediate: true,
        handler() {
          this.start()
        },
      },
    },

    activated() {
      this.start()
    },

    deactivated() {
      this._dispose?.()
    },

    beforeDestroy() {
      this._dispose?.()
    },

    methods: {
      start() {
        if (this.disabled) return
        this._dispose?.()
        const { dispose } = getSeckillInfo(this.data, info => {
          this.seckillInfo = info
          this.$emit('change', info)
          if (info.isEnded) {
            this.$emit('ended', info)
          }
        })
        this._dispose = dispose
      },
    },
  })
</script>
